<script>
export default {
  name: "ProjectMapAsphaltSortCheckboxItem",

  props: {
     asphaltType: {
      type: Object,
      default: {
        name: '',
        disabled: false,
        active: false,
      }
    },
  },

  data() {
    return {
      isActive: this.asphaltType.active,
    };
  },

  methods: {
    onActiveChange() {
      this.$emit('activeChanged', this.asphaltType)
    }
  },
};
</script>

<template>
    <label>
      <input
        type="checkbox"
        v-model="asphaltType.active"
        :disabled="asphaltType.disabled"
        class="u-no-margin--bottom"
        @change="onActiveChange"
        />
        {{ asphaltType.name }}
    </label>
</template>

